<template lang="pug">
  v-flex.forget-pw(:xs6="!mobile" :column="mobile" :style="{'padding': (!mobile) ? '15px 10px 25px 5px' : '10px 15px'}")
    v-card-title
      v-layout(align-start :class="{'pl-4' : mobile}" :column="mobile")
        v-flex(d-flex align-center style="flex: none;")
          v-btn(@click="btnEvent('backToLogin')" icon style="margin: 0;" v-if="!resetPw")
            v-icon(large) navigate_before
          span.headline(:style="{'padding-left' : resetPw ? '35px' : '0'}")
            b {{$t('auth.forgetPw')}}
        v-layout(column :align-end="!mobile" :align-start="mobile" :style="{'white-space': !mobile ? 'nowrap' : ''}" :class="mobile ? 'pl-2 pt-3' : ''")
          v-flex(d-inline-flex align-center v-for="item in step" :key="item.text")
            span(v-if="!mobile" :class="(item.value !== currentStep) ? 'achGray4--text' : 'black--text'") {{item.text}}
            .step-pointer.text-xs-center
              v-icon(style="font-size: 12px;transform: scale(0.7)" v-show="item.value === currentStep" color="black") lens
            span.pl-2(v-if="mobile" :class="(item.value !== currentStep) ? 'achGray4--text' : 'black--text'") {{item.text}}
    v-card-text.pb-5
      template(v-if="!resetPw")
        v-form.pr-1(style="padding-left: 20px; height: 150px;" v-if="currentStep === 1")
          v-text-field(prepend-icon="store_mall_directory"
                        name="brand"
                        :label="$t('auth.brand')"
                        type="text"
                        v-model="brand"
                        light
                        color="black"
                        :error-messages="errors.collect('brand')"
                        v-validate="'required'"
                        data-vv-as=" "
                        maxlength="32"
                        @keyup.enter="btnEvent(btnEventString)")
          v-text-field(prepend-icon="account_circle"
                        name="email"
                        :label="$t('auth.email')"
                        type="text"
                        v-model="email"
                        light
                        color="black"
                        :error-messages="errors.collect('email')"
                        v-validate="'required'"
                        data-vv-as=" "
                        maxlength="254"
                        @keyup.enter="btnEvent(btnEventString)")
        v-layout.mt-3(v-else-if="currentStep === 2")
          v-flex
            v-icon.mr-3 email
          v-flex
            p.body-2 {{$t('auth.forgetPwDesc.sendMailDesc')}}
            p.caption.achGray4--text {{$t('auth.forgetPwDesc.sendMailTip')}}
      template(v-else)
        v-form.pr-1(style="padding-left: 20px; height: 150px;" v-if="!resetPwInfo.isSuccessReset && !resetPwInfo.isExpired")
          v-text-field(prepend-icon="lock"
                        name="newPassword"
                        :label="$t('auth.resetPw.newPassword')"
                        type="password"
                        v-model="resetPwInfo.newPassword"
                        light
                        color="black"
                        :error-messages="errors.collect('newPassword')"
                        v-validate="'required|customPassword'"
                        data-vv-as=" "
                        maxlength="16"
                        @keyup.enter="btnEvent(btnEventString)")
          v-text-field(prepend-icon="lock"
                        name="confirmPassword"
                        :label="$t('auth.resetPw.confirmPassword')"
                        type="password"
                        v-model="resetPwInfo.confirmPassword"
                        light
                        color="black"
                        :error-messages="errors.collect('confirmPassword')"
                        v-validate="{required: true,is: resetPwInfo.newPassword}"
                        data-vv-as=" "
                        maxlength="16"
                        @keyup.enter="btnEvent(btnEventString)")
        v-layout.pt-3.pl-3(v-else)
          template(v-if="!resetPwInfo.isExpired")
            v-flex(style="flex: none;")
              v-icon.mr-4 check
            v-flex
              p.body-2 {{$t('auth.resetPw.successReset')}}
              p.caption.achGray4--text {{$t('auth.resetPw.successResetTip')}}
          template(v-else)
            v-flex(style="flex: none;")
              v-icon.mr-4 email
            v-flex
              p.body-2 {{$t('auth.resetPw.resetExpired')}}
    v-card-actions(v-if="currentStep === 1 || currentStep === 3")
      v-layout.pr-4.pt-3(column :style="{'padding-left': mobile ? '30px' : '70px'}")
        v-flex
          v-btn.elevation-3(round block dark color="achBlack" style="height: 48px;margin: 0;" @click="btnEvent(btnEventString)" :loading="loading")
            span.white--text(style="font-size: 18px") {{btnString}}
        v-flex.text-xs-center.mt-2(v-if="(currentStep === 1 || 3) && errMsg" style="max-height: 40px; overflow-y: hidden")
          span.achRed--text {{errMsg}}
</template>

<script>
import cryptoEvents from '@/events/cryptoEvents'
import cookie from 'js-cookie'

export default {
  props: {
    mobile: {
      type: Boolean,
      default: false
    },
    resetPw: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      step: [
        {text: this.$t('auth.forgetPwDesc.step1'), value: 1},
        {text: this.$t('auth.forgetPwDesc.step2'), value: 2},
        {text: this.$t('auth.forgetPwDesc.step3'), value: 3}
      ],
      currentStep: 1,
      email: '',
      brand: '',
      loading: false,
      resetPwInfo: {
        newPassword: '',
        confirmPassword: '',
        passwordCode: '',
        isSuccessReset: false,
        isExpired: false
      },
      errMsg: ''
    }
  },
  created () {
    // 如果在同一瀏覽器開啟 忘記密碼 頁面時，強制清除登入 cookie 避免被導向內頁
    if (this.resetPw && this.$route.query.code) {
      this.verifyCode()
      cookie.remove('CT')
    }
  },
  mounted () {
    // URL 為 resetPw
    if (this.resetPw) {
      this.currentStep = 3
      if (!this.$route.query.code) {
        this.resetPwInfo.isSuccessReset = false
        this.resetPwInfo.isExpired = true
      }
    } else {
      let info = this.$store.getters.recoverData
      if (info) {
        this.brand = info.brand
        this.email = info.email
      }
    }
  },
  computed: {
    btnString () {
      return (!this.resetPwInfo.isSuccessReset)
        ? (!this.resetPwInfo.isExpired)
          ? this.$t('auth.btns.submit')
          : this.$t('auth.btns.sendMailAgain')
        : this.$t('auth.btns.backToLogin')
    },
    btnEventString () {
      return (this.currentStep === 1) ? 'forgetConfirm' : (!this.resetPwInfo.isExpired && !this.resetPwInfo.isSuccessReset) ? 'resetPw' : 'backToLogin'
    }
  },
  methods: {
    verifyCode () {
      this.resetPwInfo.passwordCode = this.$route.query.code
      let params = {
        code: this.resetPwInfo.passwordCode
      }
      this.$store.dispatch('verifyResetCode', {params: params})
        .then(response => {
          this.resetPwInfo.isExpired = false
        })
        .catch(() => {
          this.currentStep = 3
          this.resetPwInfo.isExpired = true
        })
    },
    btnEvent (event) {
      switch (event) {
        case 'forgetConfirm':
          this.errMsg = ''
          this.$validator.validateAll()
            .then((result) => {
              if (result) {
                this.loading = true
                let params = {
                  service: 'chuuka',
                  brandName: this.brand,
                  email: this.email.toLowerCase()
                }
                this.$store.dispatch('forgetPw', {params: params})
                  .then(response => {
                    this.loading = false
                    this.currentStep = 2
                  })
                  .catch(err => {
                    this.loading = false
                    if (err.response.status === 400) {
                      this.errMsg = this.$t('errors.forgetPwFail')
                    } else {
                      this.$store.dispatch('errorsHandler', {params: err})
                    }
                  })
              }
            })
          break
        case 'resetPw':
          this.errMsg = ''
          if (this.resetPwInfo.passwordCode && !this.resetPwInfo.isExpired) {
            this.$validator.validateAll()
              .then((result) => {
                if (result) {
                  this.loading = true
                  let params = {
                    passwd: cryptoEvents.createHash(this.resetPwInfo.newPassword),
                    confirm_passwd: cryptoEvents.createHash(this.resetPwInfo.confirmPassword),
                    code: this.resetPwInfo.passwordCode
                  }
                  this.$store.dispatch('resetPw', {params: params})
                    .then(response => {
                      this.resetPwInfo.isSuccessReset = true
                      this.loading = false
                      let vm = this
                      setTimeout(() => {
                        vm.btnEvent('backToLogin')
                      }, 5000)
                    })
                    .catch(err => {
                      this.loading = false
                      if (typeof err.response === 'undefined' || err.response.status !== 403) this.$store.dispatch('errorsHandler', {params: err})
                      else this.errMsg = this.$t('errors.resetPwRepeat')
                    })
                }
              })
          }
          break
        case 'backToLogin':
          this.$emit('btnEvent', {action: event, data: {gotoForgetPw: !this.resetPwInfo.isSuccessReset}})
          this.currentStep = 1
          this.resetPwInfo.isExpired = false
          this.resetPwInfo.isSuccessReset = false
          break
      }
    }
  },
  watch: {
    '$route' (from, to, next) {
      if (this.resetPw) {
        // 如果進入頁面為重設密碼事件，則驗證code
        this.verifyCode()
      } else {
        // 如果非重設密碼事件且觸發回上一頁返回此頁面，則要將 isExpired 設為 false 來確定按鈕正確顯示字串
        this.resetPwInfo.isExpired = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .forget-pw /deep/
    font-size: 12px
    .card__title
      padding: 16px 0

  .step-pointer
    min-width: 20px
    min-height: 20px
</style>
